(function () {
  function escapeHtml(str) {
    return str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function formatBotText(text) {
    return escapeHtml(text)
      .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
      .replace(/\n/g, "<br>");
  }

  function initWidget(root) {
    if (root.dataset.aiChatInitialized) return;
    root.dataset.aiChatInitialized = "true";

    var apiUrl = root.getAttribute("data-api-url");
    var messagesEl = root.querySelector("[data-ai-chat-messages]");
    var welcomeEl = root.querySelector("[data-ai-chat-welcome]");
    var formEl = root.querySelector("[data-ai-chat-form]");
    var inputEl = root.querySelector("[data-ai-chat-input]");
    var sendEl = root.querySelector("[data-ai-chat-send]");
    var history = [];
    var busy = false;

    function addMessage(text, role, pending) {
      var div = document.createElement("div");
      div.className = "ai-chat-msg ai-chat-msg--" + role + (pending ? " is-pending" : "");
      if (role === "bot") {
        div.innerHTML = formatBotText(text);
      } else {
        div.textContent = text;
      }
      messagesEl.appendChild(div);
      messagesEl.scrollTop = messagesEl.scrollHeight;
      return div;
    }

    async function submitMessage(text) {
      text = text.trim();
      if (!text || busy) return;
      busy = true;

      if (welcomeEl) {
        welcomeEl.remove();
        welcomeEl = null;
      }

      addMessage(text, "user");
      inputEl.value = "";
      sendEl.disabled = true;
      var pendingEl = addMessage("Thinking…", "bot", true);

      try {
        var res = await fetch(apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ message: text, history: history }),
        });
        var data = await res.json();

        if (!res.ok) throw new Error(data.error || "Something went wrong. Please try again.");
        if (typeof data.reply !== "string") throw new Error("Sorry, Cedar couldn't answer just now. Please try again or contact our team.");

        pendingEl.innerHTML = formatBotText(data.reply);
        pendingEl.classList.remove("is-pending");

        history.push({ role: "user", content: text });
        history.push({ role: "assistant", content: data.reply });
      } catch (err) {
        pendingEl.innerHTML = formatBotText(
          err.message || "Sorry, something went wrong. Please try again or contact us directly.",
        );
        pendingEl.classList.remove("is-pending");
      } finally {
        busy = false;
        sendEl.disabled = false;
        messagesEl.scrollTop = messagesEl.scrollHeight;
        inputEl.focus({ preventScroll: true });
      }
    }

    root.querySelectorAll("[data-ai-chat-question]").forEach(function (button) {
      button.addEventListener("click", function () {
        // Read the question text without its decorative arrow.
        submitMessage(button.firstChild.textContent);
      });
    });

    formEl.addEventListener("submit", function (e) {
      e.preventDefault();
      submitMessage(inputEl.value);
    });
  }

  function init() {
    var widgets = document.querySelectorAll("[data-ai-chat-widget]");
    widgets.forEach(initWidget);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
